import { nanoid } from "nanoid";
import { Note } from "../client.imba";

function time(): string {
  const date = new Date();
  const h = date.getHours();
  const hour = h > 12 ? h - 12 : h;
  const sec = date.getSeconds();
  const secs = sec < 10 ? "0" + sec : sec;
  const min = date.getMinutes();
  const mins = min < 10 ? "0" + min : min;
  const ampm = h >= 12 ? "pm" : "am";
  return hour + ":" + mins + ":" + secs + " " + ampm;
}

export let newNote = (): Note => ({
  id: nanoid(),
  title: "A Simple Note",
  selected: true,
  data: "Start writing...",
  date: new Date().toDateString() + " @ " + time(),
});

const notes: Array<Note> = [newNote()];

export default notes;
